/* OV product page (redesign, Nov 2026): size picker, quantity, gallery, add to cart, bought together,
   sticky bar, reviews. Works with the Liquid in sections/ov-product.liquid. */
(function () {
  var root = document.querySelector('[data-ovp]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('[data-ovp-json]').textContent);
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var byId = {};
  data.variants.forEach(function (v) { byId[v.id] = v; });
  var cur = byId[data.current] || data.variants[0];
  var qtyInput = $('[data-qty-input]');

  function qty() { return Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1)); }

  /* Gallery */
  var gal = $('[data-gal]'), thumbs = $$('[data-thumbs] button'), count = $('[data-count]');
  var slides = gal ? gal.children.length : 0, shown = -1;
  function at() { return gal ? Math.round(gal.scrollLeft / (gal.clientWidth || 1)) : 0; }
  function mark(i) {
    if (i === shown) return;
    shown = i;
    if (count) count.textContent = (i + 1) + ' / ' + slides;
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }
  function go(i, instant) {
    if (!gal || i < 0 || i >= slides) return;
    if (instant) gal.scrollLeft = i * gal.clientWidth;
    else gal.scrollTo({ left: i * gal.clientWidth, behavior: 'smooth' });
    mark(i);
  }
  if (gal) {
    gal.addEventListener('scroll', function () { mark(at()); }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    $$('[data-gal-step]').forEach(function (b) {
      b.addEventListener('click', function () { go((at() + parseInt(b.getAttribute('data-gal-step'), 10) + slides) % slides); });
    });
  }

  /* Render the selected size everywhere it shows */
  function render() {
    var n = qty(), v = cur;
    var set = function (s, t) { var el = $(s); if (el) el.textContent = t; };
    set('[data-price]', money(v.price));
    set('[data-unit]', v.unit || '');
    set('[data-size-name]', v.title);
    set('[data-atc-price]', '· ' + money(v.price * n));
    set('[data-atc-label]', v.available ? 'Add to cart' : 'Sold out');
    var atc = $('[data-atc]'); if (atc && !atc.hasAttribute('aria-busy')) atc.disabled = !v.available;
    var sv = $('[data-servings]');
    if (sv && data.serving > 0) {
      var per = v.grams > 0 ? (Math.round(v.grams / data.serving * 10) / 10).toString() : '';
      sv.textContent = (per ? 'Servings per package: ' + per + ' · ' : '') + 'Serving size: ' + data.serving + 'g';
    }
    set('[data-sticky-name]', v.title || data.name || '');
    set('[data-sticky-price]', n > 1 ? n + ' × ' + money(v.price) : money(v.price));
    var sa = $('[data-sticky-atc]'); if (sa && !sa.hasAttribute('aria-busy')) { sa.disabled = !v.available; sa.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    if (v.thumb) {
      ['[data-sticky-img] img', '[data-fbt-self-img] img'].forEach(function (s) {
        var im = $(s); if (im) { im.src = v.thumb; im.removeAttribute('srcset'); }
      });
    }
    set('[data-fbt-self-v]', v.title);
    set('[data-fbt-self-p]', v.available ? money(v.price) : 'Sold out');
    /* a sold-out size can't be part of "bought together"; tick it again when an available size is picked */
    var self = $('[data-fbt-self]');
    if (self) {
      if (!v.available) { if (self.checked) self.setAttribute('data-auto-off', ''); self.checked = false; self.disabled = true; }
      else { self.disabled = false; if (self.hasAttribute('data-auto-off')) { self.checked = true; self.removeAttribute('data-auto-off'); } }
    }
    $$('[data-variant-input]').forEach(function (inp) {
      if (inp.value !== String(v.id)) { inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    fbt();
  }

  function pick(v) {
    cur = v;
    $$('[data-sizes] button').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-variant') === String(v.id) ? 'true' : 'false'); });
    render();
  }
  $$('[data-sizes] button').forEach(function (b) {
    b.addEventListener('click', function () {
      pick(byId[b.getAttribute('data-variant')]);
      if (cur.img >= 0) go(cur.img);
      try { var u = new URL(location.href); u.searchParams.set('variant', cur.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
    });
  });
  $$('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () { qtyInput.value = Math.max(1, Math.min(99, qty() + parseInt(b.getAttribute('data-qty'), 10))); render(); });
  });
  qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });

  /* Toast + cart count */
  var toast = $('[data-toast]'), tm;
  function say(html) { toast.innerHTML = html; toast.classList.add('is-on'); clearTimeout(tm); tm = setTimeout(function () { toast.classList.remove('is-on'); }, 3600); }
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: c, sourceId: 'ov-pdp', data: { itemCount: c.item_count, source: 'ov-pdp' } } })); } catch (e) {}
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count], .cart-count, [ref="cartBubbleCount"]'), function (el) { el.textContent = c.item_count; });
      /* Savor updates the bubble number but not its screen-reader text ("Total items in cart: 0") */
      Array.prototype.forEach.call(document.querySelectorAll('.cart-bubble__text > .visually-hidden'), function (el) {
        var label = (el.textContent.split(':')[0] || '').trim() || 'Total items in cart';
        el.textContent = label + ': ' + c.item_count;
      });
    }).catch(function () {});
  }
  /* The button says "Adding…" straight away and "Added" as soon as Shopify confirms; the cart count updates after */
  function addItems(items, btn, label) {
    var old = btn.innerHTML;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…';
    function done() { btn.innerHTML = old; btn.disabled = false; btn.removeAttribute('aria-busy'); render(); }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
      .then(function () {
        btn.textContent = 'Added ✓';
        say(label + ' <a href="/cart">View cart</a>');
        refreshCount();
        setTimeout(done, 1400);
      })
      .catch(function (e) { say(String(e.message || 'Could not add to cart, please try again')); done(); });
  }

  var form = $('#ovp-form') || document.getElementById('ovp-form');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!cur.available) return;
    addItems([{ id: cur.id, quantity: qty() }], $('[data-atc]'), 'Added to cart.');
  });
  var sa = $('[data-sticky-atc]');
  if (sa) sa.addEventListener('click', function () { if (cur.available) addItems([{ id: cur.id, quantity: qty() }], sa, 'Added to cart.'); });

  /* Bought together */
  var boxes = $$('[data-fbt] input'), fbtAdd = $('[data-fbt-add]');
  function fbt() {
    if (!fbtAdd || fbtAdd.hasAttribute('aria-busy')) return;
    var s = 0, c = 0;
    boxes.forEach(function (b) {
      if (!b.checked || b.disabled) return;
      s += b.hasAttribute('data-fbt-self') ? cur.price : parseInt(b.getAttribute('data-fbt-price'), 10); c++;
    });
    var tot = $('[data-fbt-total]'); if (tot) tot.textContent = money(s);
    fbtAdd.textContent = c ? 'Add ' + c + ' to cart' : 'Pick an item';
    fbtAdd.disabled = !c;
  }
  boxes.forEach(function (b) { b.addEventListener('change', function () { b.removeAttribute('data-auto-off'); fbt(); }); });
  if (fbtAdd) fbtAdd.addEventListener('click', function () {
    var items = [];
    boxes.forEach(function (b) {
      if (!b.checked || b.disabled) return;
      if (b.hasAttribute('data-fbt-self')) { if (cur.available) items.push({ id: cur.id, quantity: 1 }); }
      else items.push({ id: parseInt(b.getAttribute('data-fbt-id'), 10), quantity: 1 });
    });
    if (items.length) addItems(items, fbtAdd, 'Added ' + items.length + ' to cart.');
  });

  /* Jump links (stars to reviews) */
  $$('[data-jump]').forEach(function (a) {
    a.addEventListener('click', function (e) { var t = document.querySelector(a.getAttribute('href')); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); } });
  });

  /* Sticky bar (phones): shows once the main buy buttons have scrolled up off the screen, not while they're
     still below it, so it behaves the same on every product however long the top of the page is */
  var sticky = $('[data-sticky]'), buy = document.getElementById('ovp-buy');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      var off = !e[0].isIntersecting && e[0].boundingClientRect.bottom < 0;
      sticky.classList.toggle('is-on', off);
      sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
      if (sa) sa.tabIndex = off ? 0 : -1;
    }).observe(buy);
  }

  /* Reviews. Judge.me only finishes setting up its widget once it scrolls into view, so clicks wait for it (up to 6s).
     Both buttons stay hidden if Judge.me never loads.
     - Write a review: opens Judge.me's own review form (a pop-up).
     - Show all reviews: reveals Judge.me's full list under ours, highest rating first. Its summary, average,
       review count and bar chart stay hidden (ov-pdp.css). */
  /* Show more reviews: the best 4 show first; this opens (and closes) the rest of our list */
  var moreBtn = $('[data-more-reviews]');
  if (moreBtn) moreBtn.addEventListener('click', function () {
    var open = moreBtn.getAttribute('aria-expanded') !== 'true';
    $$('[data-rev-more]').forEach(function (r) { r.hidden = !open; });
    moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    moreBtn.textContent = open ? 'Show fewer reviews' : 'Show more reviews';
  });
  var wr = $('[data-write-review]'), allBtn = $('[data-all-reviews]'), jbox = $('.ovp-jdgm');
  function whenReady(find, fn) {
    var n = 0;
    (function check() {
      var el = find();
      if (el) return fn(el);
      if (++n < 40) setTimeout(check, 150);
    })();
  }
  if (wr || allBtn) {
    var jlink = function () { return root.querySelector('.ovp-jdgm .jdgm-write-rev-link'); };
    var tries = 0, wait = setInterval(function () {
      if (window.jdgm && jlink()) {
        if (wr) wr.hidden = false;
        if (allBtn && root.querySelector('.ovp-jdgm .jdgm-rev')) allBtn.hidden = false;
        clearInterval(wait);
      }
      if (++tries > 80) clearInterval(wait);
    }, 250);
  }
  if (wr) wr.addEventListener('click', function () {
    whenReady(function () { var l = jlink(); return l && l.style.display !== 'none' ? l : null; }, function (l) { l.click(); });
  });
  if (allBtn && jbox) allBtn.addEventListener('click', function () {
    var open = !jbox.classList.contains('is-all');
    jbox.classList.toggle('is-all', open);
    allBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    allBtn.textContent = open ? 'Hide all reviews' : 'Show all reviews';
    if (!open) return;
    whenReady(function () { return jbox.querySelector('.jdgm-rev-widg__sort-wrapper select'); }, function (sel) {
      var best = Array.prototype.filter.call(sel.options, function (o) { return /highest/i.test(o.value); })[0];
      if (best && sel.value !== best.value) { sel.value = best.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });

  render();

  /* Opened with ?variant= (a shared link, an ad, or Back from another page): show that size's photo.
     A plain visit keeps the first photo, which is the one loaded first. */
  function syncPhoto() { if (cur.img >= 0) go(cur.img, true); else mark(at()); }
  if (/[?&]variant=/.test(location.search)) syncPhoto();
  /* Back/forward cache: the browser may restore a different pressed size than the page was built with */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var b = root.querySelector('[data-sizes] button[aria-pressed="true"]');
    if (b && byId[b.getAttribute('data-variant')]) pick(byId[b.getAttribute('data-variant')]);
    syncPhoto();
  });
})();
